import compass_image from '@/resources/images/compass_images/compass_image.png';
import compass_is_image from '@/resources/images/compass_images/compass_is_image.png';

/**
 * Returns the correct image based on the device name.
 * Automatically falls back to a default Compass image if the device name is missing.
 *
 * @param {string|null|undefined} deviceName - The Compass device name
 * @returns {string} The image path
 */
export const getDeviceImage = (deviceName) => {
  if (!deviceName || typeof deviceName !== 'string') {
    return compass_image;
  }

  const normalizedName = deviceName.toLowerCase();

  if (normalizedName.includes('is')) {
    return compass_is_image;
  }

  return compass_image;
};
